import {action} from 'mobx';

import apiContentFolderGetAllStore from './apiContentFolderGetAllStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * ApiContentFolderUpdateStore
 */
class ApiContentFolderUpdateStore extends ApiBaseStore {
  /**
   * Updates folder through the api.
   *
   * @param {number} folderId
   * @param {string} folderName
   */
  @action makeRequest(folderId, folderName) {
    if (!folderId) {
      this.state = STATE_REJECTED;
      this.error = new Error('Invalid folder id given to contentFolderUpdate.');
      return;
    }

    const safeContentFolderId = String(folderId);

    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    const safeUpdateContentFolder = {
      name: folderName,
    };

    serverApi.contentFolderUpdate(
      safeContentFolderId,
      safeUpdateContentFolder
    ).then(
      action('contentFolderUpdateSuccess', () => {
        this.error = null;
        this.state = STATE_FULFILLED;
        this.data = true;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        // Clear the folder cache.
        apiContentFolderGetAllStore.refresh(true);
      }),
      action('contentFolderUpdateError', (error) => {
        this.error = error;
        this.state = STATE_REJECTED;
        this.data = false;
      })
    );
  }
}

export default new ApiContentFolderUpdateStore();
